import React from 'react';
import { BUILD_INFO } from '../build-info';

type Props = { className?: string };

type BuildInfoShape = {
  version: string;
  buildTime: string;
  gitSha?: string;
};

export default function BuildInfo({ className }: Props) {
  const info = BUILD_INFO as BuildInfoShape;
  const showSha = Boolean(info.gitSha);
  const label = showSha
    ? `v${info.version} (${info.gitSha})`
    : `v${info.version}`;

  return <span className={className}>{label}</span>;
}
